module.exports = __webpack_public_path__ + "static/img/princeAlbert1.156dce1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/princeAlbert1.jpg
// module id = 123
// module chunks = 9